import React from 'react';

import { IdleSpecialOffersPopup } from '@sravni/react-ugc/lib/IdleSpecialOffersPopup';
import { useAnalytics } from '@sravni/react-utils';

import { AB_NAME } from '../../constants/sitesettings';
import { useSpecialOffersPopupTabs } from '../../hooks/specialOffers';
import { useIsUserLogged } from '../../hooks/users';
import { isShowPopupWithSO } from '../../utils/isShowPopupWithSO';

export const SpecialOffersIdlePopup = () => {
  const tabsForSpecialOffersPopup = useSpecialOffersPopupTabs();
  const isUserLogged = useIsUserLogged();
  const { pushEvent } = useAnalytics();

  if (!tabsForSpecialOffersPopup.length || !isShowPopupWithSO) return null;

  return (
    <IdleSpecialOffersPopup
      pushEvent={pushEvent}
      abName={AB_NAME}
      tabs={tabsForSpecialOffersPopup}
      section={'Журнал'}
      isUserLogged={isUserLogged}
    />
  );
};
